import { Link } from "react-router-dom";
import { ArrowLeft, Search } from "lucide-react";
import SeoHead from "@/components/SeoHead";
import { useLang } from "@/i18n/LanguageContext";

export default function NotFound() {
  const { lang } = useLang();
  const fr = lang === "fr";
  return (
    <main className="bg-[#F6F3EE] min-h-[65vh]" data-testid="not-found">
      <SeoHead lang={lang} noindex path="/404" bareTitle title={fr ? "Page introuvable | Dataleo" : "Page not found | Dataleo"} description={fr ? "Cette page n'existe pas ou a changé d'adresse." : "This page does not exist or has moved."} />
      <div className="dl-container py-20 sm:py-28">
        <p className="font-mono-dl text-xs tracking-[0.22em] uppercase text-[#00A878]">404 · {fr ? "Page introuvable" : "Page not found"}</p>
        <h1 className="font-display text-4xl sm:text-6xl text-[#0B1210] mt-6 max-w-3xl leading-tight">
          {fr ? "Cette page n'est plus ici." : "This page isn't here."}
        </h1>
        <p className="text-[#4B5563] mt-6 text-lg max-w-xl leading-relaxed">
          {fr ? "L'adresse est peut-être incorrecte ou le contenu a été déplacé. Retrouvez nos expertises et nos analyses depuis les pages principales." : "The address may be incorrect or the content has moved. Explore our expertise and intelligence using the links below."}
        </p>
        <div className="mt-9 flex flex-wrap gap-3">
          <Link className="dl-pill dl-pill-primary" to="/"><ArrowLeft size={16}/>{fr ? "Accueil" : "Home"}</Link>
          <Link className="dl-pill dl-pill-outline" to="/capabilities">{fr ? "Nos capacités" : "Capabilities"}</Link>
          <Link className="dl-pill dl-pill-outline" to="/radar/search"><Search size={16}/>{fr ? "Rechercher dans Radar" : "Search Radar"}</Link>
        </div>
      </div>
    </main>
  );
}
